"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDraggableItemStyle = exports.getDroppableZoneStyle = exports.reorderDndItems = void 0;
var theme_1 = __importDefault(require("../../theme"));
function reorderDndItems(array, startIndex, endIndex) {
    var result = Array.from(array);
    var removed = result.splice(startIndex, 1)[0];
    result.splice(endIndex, 0, removed);
    return result;
}
exports.reorderDndItems = reorderDndItems;
function getDroppableZoneStyle(grid, _) {
    return {
        display: "flex",
        padding: grid,
    };
}
exports.getDroppableZoneStyle = getDroppableZoneStyle;
function getDraggableItemStyle(grid, isDragging, draggableStyle) {
    return __assign({ width: 100, height: 100, userSelect: "none", padding: grid, margin: "0 ".concat(grid, "px 0 0"), borderRadius: 4, border: "2px solid ".concat(isDragging
            ? theme_1.default.colorsPalette.blue.default
            : theme_1.default.colorsPalette.gray.lighter) }, draggableStyle);
}
exports.getDraggableItemStyle = getDraggableItemStyle;
//# sourceMappingURL=helpers.js.map